import React, { useContext } from "react";
import { MyContext } from "../../context/context";

const ProgramCard = ({ program }) => {
  const { setToggleEnrollForm, setSelectedCourse } = useContext(MyContext);

  return (
    <div className="program-card">
      <img src={program.icon} alt={program.name} className="pro-card-img" />

      <div className="program-content">
        <h3>{program.name}</h3>
        <p>{program.description}</p>

        {/* Optional: Skills (if you added in data) */}
        {program.skills && (
          <div className="skills">
            {program.skills.map((skill, index) => (
              <span key={index} className="skill-tag">
                {skill}
              </span>
            ))}
          </div>
        )}

        {/* CTA Button */}
        <button
          className="btn btn-primary full-width"
          onClick={() => {
            setToggleEnrollForm(true);
            setSelectedCourse(program.tag);
          }}
        >
          🚀 Request Call Back
        </button>
      </div>
    </div>
  );
};

export default ProgramCard;
